export default "__VITE_ASSET__Dq_ry9q8__"